import { css } from '@emotion/react'
import { colors, Heading, HFlow, Modal, ModalBody, ModalHeader, Text, VFlow } from 'bold-ui'
import { PecIcon } from 'view/atendimentos/list/PecIcon'

import {
  criterioInclusaoByTematica,
  listaTematicaEntries,
} from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

interface ListaTematicaInformacaoModalProps {
  isModalOpen: boolean
  setIsModalOpen(isModalOpen: boolean): void
}

export function ListaTematicaInformacaoModal(props: Readonly<ListaTematicaInformacaoModalProps>) {
  const { isModalOpen, setIsModalOpen } = props

  const handleClose = () => {
    setIsModalOpen(false)
  }

  return (
    <Modal open={isModalOpen} size='auto' onClose={handleClose} closeOnBackdropClick style={styles.modal}>
      <ModalHeader
        title='Saiba mais'
        subtitle='Como funcionam as Listas Temáticas?'
        icon={{ name: 'infoCircleOutline', fill: 'primary' }}
      />
      <ModalBody>
        <VFlow vSpacing={1.5}>
          <VFlow vSpacing={0.5}>
            <VFlow vSpacing={1}>
              <Text>
                Cada lista temática exibe as pessoas que atendem aos critérios de seleção definidos para aquele tema.
                Esses critérios foram definidos com base em boas práticas em saúde, mas podem ser ajustados pelo usuário
                por meio dos filtros disponíveis, de acordo com a necessidade de cada equipe.
              </Text>
              <Text>
                O processamento das listas ocorre diariamente. Por isso, alterações registradas no Prontuário no dia
                atual podem ainda não estar refletidas nos resultados apresentados.
              </Text>
              <Text>
                Todas as listas consideram apenas pessoas que tiveram atendimento individual nos últimos 3 anos. Esse
                filtro (Período do último atendimento) pode ser removido para incluir pessoas independentemente da data
                do último atendimento individual.
              </Text>
            </VFlow>
            <Text>Abaixo, veja os critérios de inclusão específicos de cada lista temática:</Text>
          </VFlow>
          <VFlow vSpacing={1.5}>
            {listaTematicaEntries.map(([tematica, { titulo, icone }]) => (
              <VFlow key={tematica} vSpacing={0.25}>
                <HFlow alignItems='center' hSpacing={0.5}>
                  <PecIcon icon={icone} color={colors.gray.c40} size={1.25} />
                  <Heading level={5}>{titulo}</Heading>
                </HFlow>
                <Text>{criterioInclusaoByTematica[tematica]}</Text>
              </VFlow>
            ))}
          </VFlow>
        </VFlow>
      </ModalBody>
    </Modal>
  )
}

const styles = {
  modal: css`
    width: 56.25rem;
    max-width: 62rem;
    display: flex;
    flex-direction: column;
  `,
}
